import { M as MathProportionCalculator } from './mathProportionCalculator-1f90427a.js';
import { M as MathRandomizer } from './mathRandomizer-15b806e5.js';
import { M as MathPrecisionTool } from './mathPrecisionTool-7b91146f.js';

class MathUtils {
}
MathUtils.precision = MathPrecisionTool;
MathUtils.proportion = MathProportionCalculator;
MathUtils.randomization = MathRandomizer;

export { MathUtils as M };
//# sourceMappingURL=mathUtils-f6581b44.js.map
